import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { Box, Button } from '@mui/material';

import { paths } from 'src/routes/paths';
import { Iconify } from 'src/components/iconify';

import BrevoIntegration from '@/components/settings/BrevoIntegration';

export const Route = createFileRoute(
  '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/brevo',
)({
  component: BrevoIntegrationPage,
});

function BrevoIntegrationPage() {
  const navigate = useNavigate();
  const { orgId, clientId } = Route.useParams();

  return (
    <Box>
      <Button
        size="small"
        startIcon={<Iconify icon="eva:arrow-back-fill" width={16} />}
        onClick={() =>
          navigate({
            to: paths.dashboard.orgSettings(orgId).client.clientIntegrations(clientId),
          })
        }
        sx={{ mb: 2, textTransform: 'none' }}
      >
        Back to Integrations
      </Button>
      <BrevoIntegration />
    </Box>
  );
}
